import React from "react";

function Home(){

    return <img className="img-fluid" src={require('../images/smartinspect.JPG')} />;

}

export default Home;